var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStudentsV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.156 5.462a2.418 2.418 0 1 0 0-4.837 2.418 2.418 0 0 0 0 4.837m0-3.587a1.168 1.168 0 1 1 0 2.337 1.168 1.168 0 0 1 0-2.337M6.875 5.938H3.438a1.877 1.877 0 0 0-1.876 1.875v5.937h1.25v5.625H7.5V13.75h1.25V7.813a1.877 1.877 0 0 0-1.875-1.875M7.5 12.5H6.25v5.625H4.063V12.5h-1.25V7.813a.626.626 0 0 1 .624-.625h3.438a.626.626 0 0 1 .625.625zM14.457 5.462a2.418 2.418 0 1 0 0-4.837 2.418 2.418 0 0 0 0 4.837m0-3.587a1.169 1.169 0 1 1 0 2.337 1.169 1.169 0 0 1 0-2.337M16.631 7.553a2.406 2.406 0 0 0-4.524-.055l-2.42 6.45v1.677h2.5v3.75h4.063v-3.75h2.5v-1.98zm.869 6.822H15v3.75h-1.562v-3.75h-2.5v-.2l2.339-6.238a1.155 1.155 0 0 1 2.174.026l2.049 5.892z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudentsV2);
export default ForwardRef;